// /web/src/data/pricingTiers.js
export const pricingTiers = [
  {
    plan: "lite",
    name: "Solo",
    price: "£9",
    meta: "/mo",
    desc: "For single projects.",
    perks: [
      { text: "Unlimited calculations" },
      { text: "1 active project" },
      { text: "Email support" },
    ],
    cta: "Choose Solo",
  },
  {
    plan: "studio",
    name: "Studio",
    price: "£24",
    meta: "/mo",
    desc: "For small teams or multiple projects.",
    perks: [
      { text: "Unlimited calculations" },
      { text: "Up to 10 active projects" },
      { text: "Priority support" },
    ],
    cta: "Choose Studio",
    featured: true,
  },
  {
    plan: "practice",
    name: "Practice",
    price: "£49",
    meta: "/mo",
    desc: "For larger practices or unlimited use.",
    perks: [
      { text: "Unlimited calculations" },
      { text: "Unlimited projects" },
      { text: "Dedicated support" },
    ],
    cta: "Choose Practice",
  },
];
